import t from"../../../../../@emotion/styled/dist/emotion-styled.browser.esm.js";function o(o,e){return t(o,e)}const e=(t,o)=>{Array.isArray(t.__emotion_styles)&&(t.__emotion_styles=o(t.__emotion_styles))};export{o as default,e as internal_processStyles};
//# sourceMappingURL=index.js.map
